import { FormEvent, ReactNode, useRef } from "react";
import { AttributeCollection } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { AttributeDefinition, GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { UpdateStyleFunction } from "../Stylebuilder";
import { SiteData } from "../Data/SiteData";
type SliderFieldProps  = {
    label:ReactNode,
    definition:AttributeDefinition,
    screenSize:ScreenSize,
    layoutObject:AttributeCollection,
    updateFunc:UpdateStyleFunction,
    saveFunc:Function,
    siteData:SiteData,
    providedVal?:string

}

export default function SliderFieldNoLabel({definition,layoutObject,updateFunc,saveFunc,screenSize,providedVal,trailing,allowAuto}:SliderFieldProps&{trailing?:ReactNode,allowAuto?:boolean}){

    let val =  GetComponentOrStyleValueFromDefinition(definition,layoutObject,screenSize);
    if(providedVal)
        val = providedVal;


    let parse = parseFloat(val);

    let match = val.match(/(\d+)/);



    const textInputRef = useRef<HTMLInputElement>(null);
    const rangeInputRef = useRef<HTMLInputElement>(null)

    const updateFromSlider = (e:FormEvent)=>{
        if(rangeInputRef.current&&textInputRef.current){
            textInputRef.current.value = rangeInputRef.current.value;
            updateFunc(definition.attKey,textInputRef.current.value+definition.range.unit,definition.targetType);
         }
    }

    const updateFromText = (e:FormEvent)=>{

        if(rangeInputRef.current&&textInputRef.current){
           rangeInputRef.current.value = textInputRef.current.value;
            if(textInputRef.current.value==""){
                updateFunc(definition.attKey,"",definition.targetType);
            }
            else
                updateFunc(definition.attKey,rangeInputRef.current.value+definition.range.unit,definition.targetType);
        }
    }

    let number = 0;//definition.range.min;
    if(parse){
        number = parse;
    }

    else if(match&&match.length>0){
        number = parseFloat(match[0]);
    }
    else{
        number = definition.range?.default??0;
    }

    if(number<definition.range.min)
        number = definition.range.min;



    let deflt = definition.range.default?.toString()??"";
    let current:string = (val=="")?deflt:number.toString();
    let defaultNum = (allowAuto&&val=="")?"":current;

    let mid = (definition.range.max-definition.range.min)/2;

    let sliderDef = current==""?mid:current;
    if(allowAuto &&val==""){
        sliderDef = mid;
    }

    return(<div className="wb-input-row">
        <input type='range' defaultValue={sliderDef} ref={rangeInputRef} min={definition.range.min} max={definition.range.max} step={definition.range.step} onInput={updateFromSlider}  onMouseUp={()=>{saveFunc();}}/>
        <div className="range-text">
            <input type='number' placeholder="Auto" defaultValue={defaultNum} ref={textInputRef} min={definition.range.min} onInput={updateFromText}  max={definition.range.max} step={definition.range.step} onChange={()=>{saveFunc()}}/>

            <span>{definition.range.unit}</span>
        </div>
        {trailing}
    </div>
    );
}